export default "__VITE_ASSET__Cup_ka5r__"